import * as yup from "yup";
import {
  BIANNUALLY,
  MONTHLY,
  QUARTERLY,
  WEEKLY,
  YEARLY,
} from "../utils/report";

const reportBaseSchema = yup.object().shape({
  ReportName: yup.string().required("Report Name Required"),
  PMSReportName: yup.string().required("PMS Report Name required"),
  signature_type: yup.string().required(),
  ReportOrder: yup.number().nullable(true),
  SourceType: yup.string().required("Source Type not Selected"),
  business_date: yup.string().required("Business Date not Selected"),
  schedule_trigger_type: yup
    .number()
    .test(
      "is-valid-schedule-trigger-type",
      "schedule type not selected",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          [MONTHLY, QUARTERLY, BIANNUALLY, YEARLY].includes(
            parent.shedule_type,
          ) && !value
        );
      },
    ),
  schedule_weekday: yup
    .string()
    .test(
      "is-valid-schedule",
      "Schedule not Selected",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          [WEEKLY, MONTHLY, QUARTERLY, YEARLY].includes(parent.shedule_type) &&
          !value
        );
      },
    ),
  deactivation_date: yup
    .mixed()
    .nullable()
    .optional()
    .test(
      "is-valid-deactivation-date",
      "Invalid Deactivation Date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.activation_date &&
          value < parent.activation_date
        );
      },
    ),
  signature_activation_date: yup
    .mixed()
    .nullable()
    .optional()
    .test(
      "is-sa-date-after-activation-date",
      "Signature Activation Date Should Be After The Report Activation Date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.signature_type === "2" &&
          parent.activation_date &&
          value < parent.activation_date
        );
      },
    )
    .test(
      "is-sa-date-before-deactivation-date",
      "Signature activation date should be before the report deactivation date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.signature_type === "2" &&
          parent.deactivation_date &&
          value > parent.deactivation_date
        );
      },
    ),
  signature_deactivation_date: yup
    .mixed()
    .nullable()
    .optional()
    .test(
      "is-sd-date-after-activation-date",
      "Signature Deactivation Date Should Be After The Report Activation Date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.signature_type === "2" &&
          parent.activation_date &&
          value < parent.activation_date
        );
      },
    )
    .test(
      "is-sd-date-before-deactivation-date",
      "Signature Deactivation Date should Be Before Or The Same As The Report Deactivation Date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.signature_type === "2" &&
          parent.deactivation_date &&
          value > parent.deactivation_date
        );
      },
    )
    .test(
      "is-sd-date-before-sa-date",
      "Signature Deactivation Date Should Be After The Signature Activation Date",
      (value, testContext) => {
        const { parent } = testContext;
        return !(
          value &&
          parent.signature_type === "2" &&
          parent.deactivation_date &&
          value < parent.signature_activation_date
        );
      },
    ),
});

const generateReportNameValidator = (allReports) =>
  yup
    .string()
    .required("Report Name Required")
    .test(
      "is-report-name-already-exist",
      "Report Name already exists",
      (value, testContext) => {
        const { parent } = testContext;
        return (
          allReports.findIndex(
            (report) =>
              report.ReportName.toUpperCase().trim() ===
                value.toUpperCase().trim() &&
              parent._id !== report._id &&
              report.shedule_type === parent.shedule_type,// to be reviewed. most probably, field should be switched to report type
          ) === -1
        );
      },
    );

const generateReportOrderValidator = (allReports) =>
  yup
    .number()
    .nullable(true)
    .test(
      "is-report-order-already-exist",
      "Report Order is already exists",
      (value, testContext) => {
        const { parent } = testContext;
        return (
          allReports.findIndex(
            (report) =>
              typeof report.ReportOrder === "number" &&
              report.shedule_type === parent.shedule_type &&
              report.ReportOrder === value &&
              report._id !== parent._id,
          ) === -1
        );
      },
    );

export const getReportUpdateSchema = (allReports) =>
  yup.object().shape({
    report: yup.object().shape({
      ...reportBaseSchema.fields,
      ReportName: generateReportNameValidator(allReports),
      ReportOrder: generateReportOrderValidator(allReports),
    }),
  });

export const getReportCopyOverSchema = (allReports) =>
  yup.object().shape({
    report: yup.array().of(
      yup.object().shape({
        ...reportBaseSchema.fields,
        ReportName: generateReportNameValidator(allReports),
      }),
    ),
  });

export const additionalReportsSchema = yup.object().shape({
  formData: yup.array().of(
    yup.object().shape({
      ...reportBaseSchema.fields,
      ReportName: yup
        .string()
        .required("Report Name Required")
        .test(
          "case-insensitive-report-name-exist",
          "Cannot create duplicate reports - Please check the Report Names",
          (value, testContext) => {
            const { from, parent } = testContext;
            return !(
              from[1].value.formData.filter(
                (record) =>
                  record.ReportName.toLowerCase().trim() ===
                    value.toLowerCase().trim() &&
                  record.report_type === parent.report_type,
              ).length > 1
            );
          },
        ),
    }),
  ),
});

export default {
  getReportUpdateSchema,
  additionalReportsSchema,
  getReportCopyOverSchema,
};
